import React from 'react';

import {IMG_DIR} from '#Client/components/constants';
export const Close = ({
  className,
  onClick,
}: {
  className?: string;
  onClick: () => void;
}) => (
  <img
    className={className}
    height="64"
    src={`${IMG_DIR}pictoicon_clear.png`}
    width="64"
    onClick={onClick}
  />
);
